const schoolActivationMixin = {
  computed: {
    isActivationProcess () { return !!this.$route.name.includes('school-activation') },
    schoolUuidInLeadContext  () {
      // if there is no school-activation use selected school from user.
      // uuid -> selected school to activate
      // schoolUuid -> selected management school
      return this.$route.params.uuid || this.$route.params.schoolUuid
    },
  }
}

export default schoolActivationMixin
